module.exports = __webpack_public_path__ + "img/puberty-decal-16.13a66efd.png";